import React from 'react';
import { Button } from './ui/Button';
import { Star, ShieldCheck, Heart, Sparkles, Gift, Sun } from 'lucide-react';
export function Hero() {
  return <div className="relative overflow-hidden bg-gradient-to-b from-[#FFFDF5] via-[#FFF9E6] to-[#FFFDF5] pt-8 pb-16 lg:pt-16 lg:pb-24" data-id="element-208">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 -mr-20 -mt-20 w-96 h-96 bg-[#F5C842] opacity-20 rounded-full blur-3xl" data-id="element-209"></div>
      <div className="absolute bottom-0 left-0 -ml-20 -mb-20 w-80 h-80 bg-[#4AAAA5] opacity-15 rounded-full blur-3xl" data-id="element-210"></div>
      <div className="absolute top-20 left-[15%] text-[#F5C842] opacity-40 animate-float" data-id="element-211">
        <Sun className="w-6 h-6 fill-current" data-id="element-212" />
      </div>
      <div className="absolute top-1/4 left-10 text-[#F5C842] opacity-30 animate-float" style={{
      animationDelay: '0.3s'
    }} data-id="element-213">
        <Star className="w-8 h-8 fill-current" data-id="element-214" />
      </div>
      <div className="absolute top-1/3 right-16 text-[#E8845F] opacity-30 animate-float" style={{
      animationDelay: '1s'
    }} data-id="element-215">
        <Heart className="w-6 h-6 fill-current" data-id="element-216" />
      </div>
      <div className="absolute bottom-1/4 left-1/4 text-[#4AAAA5] opacity-25 animate-float" style={{
      animationDelay: '0.5s'
    }} data-id="element-217">
        <Sparkles className="w-7 h-7" data-id="element-218" />
      </div>
      <div className="absolute bottom-1/3 right-1/4 text-[#F5C842] opacity-20 animate-float" style={{
      animationDelay: '1.5s'
    }} data-id="element-219">
        <Star className="w-5 h-5 fill-current" data-id="element-220" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-221">
        <div className="max-w-3xl mx-auto text-center space-y-6" data-id="element-222">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-gradient-to-r from-[#E6F4F4] to-[#D4EFED] text-[#4AAAA5] font-semibold text-sm shadow-sm" data-id="element-223">
            <Star className="w-4 h-4 mr-2 fill-current" data-id="element-224" />
            Más de 1,000 familias felices
          </div>

          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-5xl font-extrabold text-gray-800 leading-tight" data-id="element-225">
            Cuando la mañana se convierte en pelea,{' '}
            <span className="relative inline-block" data-id="element-226">
              <span className="text-[#E8845F]" data-id="element-227">no es falta de paciencia</span>
              <svg className="absolute -bottom-1 left-0 w-full" viewBox="0 0 200 8" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-228">
                <path d="M2 6C50 2 150 2 198 6" stroke="#F5C842" strokeWidth="3" strokeLinecap="round" data-id="element-229" />
              </svg>
            </span>
            : es falta de <span className="text-[#4AAAA5]" data-id="element-230">claridad</span>.
          </h1>

          {/* Kit Image - between title and subtitle */}
          <div className="relative mx-auto w-full max-w-sm py-2" data-id="element-231">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl border-8 border-white/80 bg-white" data-id="element-232">
              <img src="https://cdn.magicpatterns.com/uploads/csN58Nbj9T719GyQZvkfKA/kit.png" alt="Kit de Rutinas Visuales Anti-Berrinches" className="w-full h-auto object-cover" data-id="element-233" />
            </div>
            {/* Sparkle decoration */}
            <div className="absolute -top-3 -left-3 text-[#F5C842] animate-pulse-soft" data-id="element-234">
              <Sparkles className="w-8 h-8" data-id="element-235" />
            </div>
          </div>

          <p className="text-lg text-gray-600 leading-relaxed max-w-xl mx-auto" data-id="element-236">
            Si tu mañana empieza con apuros, resistencia y discusiones… no es
            que estés fallando como mamá o papá. Es que tu hijo, en medio del
            caos,{' '}
            <span className="font-bold text-[#4AAAA5]" data-id="element-237">
              no puede anticipar qué sigue
            </span>
            .
          </p>

          <p className="text-gray-600 max-w-xl mx-auto" data-id="element-238">
            <span className="font-semibold" data-id="element-239">Un kit imprimible</span> para
            convertir la mañana en una secuencia clara, visible y sostenida.
          </p>

          <div className="inline-flex items-center px-4 py-2 rounded-full bg-gradient-to-r from-[#FFF5E6] to-[#FFEDD5] text-[#E8845F] font-semibold text-sm shadow-sm" data-id="element-240">
            <Gift className="w-4 h-4 mr-2" data-id="element-241" />Y de regalo recibes el Manual de
            Implementación (eBook)
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-2" data-id="element-242">
            <Button size="lg" withIcon onClick={() => document.getElementById('pricing')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-243">
              ¡Quiero mañanas en paz!
            </Button>
            <p className="text-sm text-gray-500 flex items-center font-medium" data-id="element-244">
              <ShieldCheck className="w-4 h-4 mr-1.5 text-[#4AAAA5]" data-id="element-245" />
              Descarga inmediata
            </p>
          </div>
        </div>
      </div>
    </div>;
}